import { renderDate } from '../utility/personTabGridHelper';

export const DEFAULT_VALUES = {
  ptsPlaceID: null,
  DepartmentName: '',
  Position: '',
  Occupation: '',
  Rank: '',
  Status: '',
  Pay: '',
  Rate: '',
  ptsSupervisorID: null,
  Shift: '',
  Hired: null,
  Terminated: null,
  TerminationReason: '',
  Notes: '',
};

export const EMPLOYMENT_GRID_COLUMNS = [
  { field: 'PlaceName', headerName: 'Employer', width: 200 },
  { field: 'PlaceType', headerName: 'Employer Type', width: 160 },
  { field: 'DepartmentName', headerName: 'Department', width: 170 },
  { field: 'Position', headerName: 'Position', width: 160 },
  { field: 'Shift', headerName: 'Shift', width: 140 },
  { field: 'Occupation', headerName: 'Occupation', width: 160 },
  { field: 'Pay', headerName: 'Pay', width: 130 },
  { field: 'Rate', headerName: 'Rate', width: 130 },
  { field: 'Rank', headerName: 'Rank', width: 140 },
  { field: 'Status', headerName: 'Status', width: 140 },
  { field: 'Hired', headerName: 'Hired', width: 170, valueFormatter: renderDate },
  { field: 'Terminated', headerName: 'Terminated', width: 170, valueFormatter: renderDate },
  { field: 'TerminationReason', headerName: 'Termination Reason', width: 190 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
